export default __webpack_public_path__ + "static/reed-1-bdfbf267c7a6469212c62c48e66b3966.webp";